
import { useContext, useState } from 'react';
import './Interchangeability.css';
import Item from '../../../../components/Lists/Item';
import { DropdownsContext, DropdownsProvider, useDropdownConfig } from '../../../../contexts/DropdownsContext';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import { dropdownConfig } from '../../../../services/dropdownsConfigService';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import InterchangeabilityList from './InterchangeabilityList';
import { InterchangeabilityContext, InterchangeabilityProvider } from '../../contexts/InterchangeabilityContext';

const NewButton = () => {
  const {addItem} = useContext(InterchangeabilityContext);
  return (
    <button className='outlined icon mid-size' onClick={()=>addItem()}>
      <i className='icon-add-new'></i>
    </button>
  )
}

const Interchangeability = ({part}) => {

  // const [underEdition, setUnderEdition] = useState({});

  // const isUnderEdition = (item) => item.id in underEdition;
  // // const startEditing = (item) => setUnderEdition(prev => ({ ...prev, [item.id]: item }));
  // const save = (item) => setUnderEdition(prev => {
  //   let copy = { ...prev };
  //   delete copy[item.id];
  //   return copy;
  // });

  return (
    // <InterchangeabilityProvider part={part}>
      <div className='section interchangeability-component'>
        <div className='section-header'>
          <h2>Interchangeability</h2>
          {/* <NewButton /> */}
          {/* <div className="search-bar-input">
            <input placeholder="Search" />
            <i className="icon-search"></i>
          </div> */}
        </div>
        <InterchangeabilityList part={part}/>
      </div>
    // </InterchangeabilityProvider>
  )
}

export default Interchangeability;